import React, { useState } from 'react';
import { Button, Card, List } from 'antd';
import { useParams } from 'react-router-dom';
import BacklogItem from './BacklogItem';
import SprintHeader from './SprintHeader';
import CreateTaskBar from './CreateTaskBar';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  useDroppable,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Cookies from 'js-cookie';
import { setsprintdata } from 'store/actions';
import { useFetchBacklogData } from 'views/admin/taskManagement/BackLogPage/Alldata';

function SprintDropZone({ sprintId }) {
  const { setNodeRef, isOver } = useDroppable({ id: `sprint-${sprintId}` });
  return (
    <div
      ref={setNodeRef}
      style={{
        minHeight: 48,
        background: isOver ? '#f0f0f0' : 'transparent',
        border: '1px dashed #ccc',
        marginBottom: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#aaa',
      }}
    >
      Plan a sprint by dragging work items into it
    </div>
  );
}
function SortableBacklogItem(props) {
  const { task } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: task.key });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
    marginBottom: 8,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <BacklogItem {...props} />
    </div>
  );
}

const SprintListSection = ({
  sprint,
  sprints,
  setSprints,
  selectedSprintKeys,
  setSelectedSprintKeys,
  fetchBacklogData,
  handleUpdateTaskFromSprint,
  handleDeleteTask,
  handleMoveTask,
  epicOptions,
  statusOptions,
  assigneeOptions,
  labelOptions,
  handleUpdateLabel,
  handleTaskClick,
  sprintCounts,
  sprintBacklogList,
  sprintList,
  handleAddTaskToSprint,
     selectedTask
}) => {
 
  const [createVisible, setCreateVisible] = useState({});
  const [collapsedMap, setCollapsedMap] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const roleId = Number(Cookies.get('task-role-id'));

  const dispatch = useDispatch();
  //const sprints = useSelector(state => state.Authentication.backlogdata)
  //console.log('sprint List Section',sprints)

  const { id } = useParams();
  const projectId = Number(id);

  //  const { fetchBacklogData,sprints, setSprints, backlogData, setBacklogData } =
  //   useFetchBacklogData( projectId);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    }),
  );

  const handleSelectSprintTask = (key, checked) => {
    setSelectedSprintKeys((prev) =>
      checked ? [...prev, key] : prev.filter((k) => k !== key),
    );
  };

  const handleSelectAllSprintTasks = (sprintId, checked) => {
    const sprint = sprints.find((s) => s.sprint_id === sprintId);
    const sprintKeys = sprint?.tasks?.map((task) => task.key) || [];
    setSelectedSprintKeys((prev) =>
      checked
        ? [...new Set([...prev, ...sprintKeys])]
        : prev.filter((key) => sprintKeys && !sprintKeys.includes(key)),
    );
  };

  const toggleCreate = (sprintId) => {
    setCreateVisible((prev) => ({ ...prev, [sprintId]: !prev[sprintId] }));
  };

  const toggleCollapse = (id) => {
    setCollapsedMap((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      {/* {sprints &&
        sprints.map((sprint) => {
          const allSelected =
            sprint.tasks.length > 0 &&
            sprint.tasks.every(
              (task) =>
                selectedSprintKeys && selectedSprintKeys.includes(task.key),
            ); */}

      {/* return ( */}
      <Card
        key={sprint.sprint_id}
        style={{ marginBottom: 24 }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ padding: '16px' }}>
          <SprintHeader
            sprint={sprint}
            title={sprint.name}
            sprint_id={sprint.sprint_id}
            projectId={projectId}
            taskCount={sprint.tasks.length}
            fetchBacklogData={fetchBacklogData}
            collapsed={collapsedMap[sprint.sprint_id] ?? false}
            onCollapseToggle={() => toggleCollapse(sprint.sprint_id)}
            isOpen={isOpen}
            sprintCounts={sprintCounts}
            onSelectAll={(checked) =>
              handleSelectAllSprintTasks(sprint.sprint_id, checked)
            }
            onDelete={() =>
              setSprints((prev) =>
                prev.filter((s) => s.sprint_id !== sprint.sprint_id),
              )
            }
          />

          {!(collapsedMap[sprint.sprint_id] ?? false) && (
            <>
              <SortableContext
                items={sprint.tasks.map((task) => task.key)}
                strategy={verticalListSortingStrategy}
              >
                {sprint.tasks.length === 0 ? (
                  <SprintDropZone sprintId={sprint.sprint_id} />
                ) : (
                  //  [1, 2, 3, 4, 5].includes(roleId) &&
                  sprint.tasks.map((task) => (
                    <SortableBacklogItem
                      key={task.key}
                      task={task}
                      isSelected={
                        selectedSprintKeys &&
                        selectedSprintKeys.includes(task.key)
                      }
                      handleUpdateTaskFromSprint={handleUpdateTaskFromSprint}
                      projectId={projectId}
                      sprint_id={sprint.sprint_id}
                      fetchBacklogData={fetchBacklogData}
                      handleDeleteTask={handleDeleteTask}
                      sprintList={sprintList}
                      sprintBacklogList={sprintBacklogList}
                      handleMoveTask={handleMoveTask}
                      epicOptions={epicOptions}
                      statusOptions={statusOptions}
                      assigneeOptions={assigneeOptions}
                      labelOptions={labelOptions}
                      handleUpdateLabel={handleUpdateLabel}
                         selectedTask={selectedTask}
                      onSelect={(key, checked) =>
                        handleSelectSprintTask(task.key, checked)
                      }
                      handleTaskClick={handleTaskClick}
                      onDelete={() =>
                        setSprints((prev) =>
                          prev.filter((s) => s.sprint_id !== sprint.sprint_id),
                        )
                      }
                    />
                  ))
                )}
              </SortableContext>

              {[1, 2, 3]?.includes(roleId) &&
                (createVisible[sprint.sprint_id] ? (
                  <CreateTaskBar
                    onAddTask={(task) => {
                      handleAddTaskToSprint(sprint.sprint_id, task);
                      toggleCreate(sprint.sprint_id);
                    }}
                    onClose={() => setCreateVisible(false)}
                  />
                ) : (
                  <Button
                    type="primary"
                    onClick={() => toggleCreate(sprint.sprint_id)}
                    style={{
                      marginTop: 8,
                      backgroundColor: '#722ed1',
                      color: 'white',
                    }}
                  >
                    + Create
                  </Button>
                ))}
            </>
          )}
        </div>
      </Card>
      {/* ); */}
      {/* })} */}
    </>
  );
};

export default SprintListSection;
